import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
    CreditReviewFormGroup,
    FinanceReviewFormGroup,
    InvestigationReviewDomesticFormGroup,
    InvestigationReviewInternationalFormGroup,
    ManagerReviewFormGroup
} from '../models/cod-review.model';
import { CodAttachment } from '../models/cod-create.model';
import {
    ReviewResult,
    NatureOfComplaintDomestic,
    NatureOfComplaintInternational,
    ReviewNextStep,
    Through,
    RootCause
} from '@cod-monorepo/interfaces';
import { WorkflowValidators } from '../validators/workflow-validators';

export class CodReviewOperations {
    public static initializeCreditReviewForm(): FormGroup<CreditReviewFormGroup> {
        return new FormGroup<CreditReviewFormGroup>({
            financialAdjustment: new FormControl<string | null>(null, Validators.required),
            creditReviewRelatedDocuments: new FormControl<CodAttachment[] | null>(null)
        });
    }

    public static initializeInvestigationReviewInternationalForm(): FormGroup<InvestigationReviewInternationalFormGroup> {
        return new FormGroup<InvestigationReviewInternationalFormGroup>(
            {
                natureOfComplaint: new FormControl<NatureOfComplaintInternational | null>(null),
                issueType: new FormControl<string | null>(null),
                rootCause: new FormControl<RootCause | null>(null),
                through: new FormControl<Through | null>(null),
                details: new FormControl<string | null>(null),
                investigationReviewRelatedDocuments: new FormControl<CodAttachment[] | null>(null),
                investigatorReviewResult: new FormControl<ReviewResult | null>(null),
                reasonForDenial: new FormControl<string | null>(null)
            },
            {
                validators: [
                    WorkflowValidators.required([
                        'natureOfComplaint',
                        'through',
                        'details',
                        'investigatorReviewResult'
                    ]),
                    WorkflowValidators.investigatorReview()
                ]
            }
        );
    }

    public static initializeInvestigationReviewDomesticForm(): FormGroup<InvestigationReviewDomesticFormGroup> {
        return new FormGroup<InvestigationReviewDomesticFormGroup>(
            {
                natureOfComplaint: new FormControl<NatureOfComplaintDomestic | null>(null),
                issueType: new FormControl<string | null>(null),
                rootCause: new FormControl<RootCause | null>(null),
                through: new FormControl<Through | null>(null),
                csrResponsible: new FormControl<string | null>(null),
                details: new FormControl<string | null>(null),
                investigationReviewRelatedDocuments: new FormControl<CodAttachment[] | null>(null),
                investigatorReviewResult: new FormControl<ReviewResult | null>(null),
                reasonForDenial: new FormControl<string | null>(null),
                nextStep: new FormControl<ReviewNextStep | null>(null)
            },
            {
                validators: [
                    WorkflowValidators.required(['natureOfComplaint', 'details', 'investigatorReviewResult']),
                    WorkflowValidators.investigatorReviewDomestic()
                ]
            }
        );
    }

    public static initializeManagerReviewForm(): FormGroup<ManagerReviewFormGroup> {
        return new FormGroup<ManagerReviewFormGroup>(
            {
                relatedManagerReview: new FormControl<ReviewResult | null>(null, Validators.required),
                reasonForDenial: new FormControl<string | null>(null),
                nextStep: new FormControl<ReviewNextStep | null>(null)
            },
            {
                validators: [WorkflowValidators.managerReview()]
            }
        );
    }

    public static initializeFinanceReviewForm(): FormGroup<FinanceReviewFormGroup> {
        return new FormGroup<FinanceReviewFormGroup>(
            {
                financeCodReview: new FormControl<ReviewResult | null>(null, Validators.required),
                reasonForDenial: new FormControl<string | null>(null),
                nextStep: new FormControl<ReviewNextStep | null>(null)
            },
            {
                validators: [WorkflowValidators.financeReview()]
            }
        );
    }
}
